import { apiRequest } from "../lib/apiClient";
import type { ApprovalDecisionRequest, ApprovalRequestOut, ApprovalRuleCreate, ApprovalRuleOut } from "./types";

/** `GET /approval-requests` — gated by `require_permission("purchase_order.approve")`,
 * platform default OWNER-only (see `types.ts`'s note). Optional filters. */
export async function listApprovalRequests(
  accessToken: string,
  filters: { status?: string; entityType?: string } = {},
): Promise<ApprovalRequestOut[]> {
  return apiRequest<ApprovalRequestOut[]>("/approval-requests", {
    accessToken,
    query: { status_filter: filters.status, entity_type: filters.entityType },
  });
}

export async function approveApprovalRequest(
  accessToken: string,
  requestId: string,
  body: ApprovalDecisionRequest = {},
): Promise<ApprovalRequestOut> {
  return apiRequest<ApprovalRequestOut>(`/approval-requests/${requestId}/approve`, {
    method: "POST",
    accessToken,
    body,
  });
}

export async function rejectApprovalRequest(
  accessToken: string,
  requestId: string,
  body: ApprovalDecisionRequest = {},
): Promise<ApprovalRequestOut> {
  return apiRequest<ApprovalRequestOut>(`/approval-requests/${requestId}/reject`, {
    method: "POST",
    accessToken,
    body,
  });
}

/** `GET/POST /approval-rules` — gated by `require_permission("approval_rule.manage")`. */
export async function listApprovalRules(accessToken: string): Promise<ApprovalRuleOut[]> {
  return apiRequest<ApprovalRuleOut[]>("/approval-rules", { accessToken });
}

export async function createApprovalRule(accessToken: string, body: ApprovalRuleCreate): Promise<ApprovalRuleOut> {
  return apiRequest<ApprovalRuleOut>("/approval-rules", { method: "POST", accessToken, body });
}
